import { CategoryPageContentAjax } from './category-page-content.backend-model';
import { CategoryPageContent } from './category-page-content.model';

export function transformCategoryPageContent(
  response: CategoryPageContentAjax,
): CategoryPageContent {
  const articles = response.articles.map(article => ({
    id: article.id,
    title: article.title,
    lead: article.lead,
    coverImageUrl: article.cover_image,
    canonicalUrl: article.canonical_url,
    readTime: article.read_time,
  }));

  return {
    id: response.id,
    name: response.name,
    seoUrl: response.seo_url,
    bannerId: response.discover_category_banner_id,
    order: response.order,
    portfolioItemIds: response.portfolio_item_ids,
    articles,
    freelancerIds: response.freelancer_ids,
    skillIds: response.skill_ids,
    isPrivate: response.is_private,
    isDeleted: response.deleted,
  };
}
